import { motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';

function SsoCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      toast.error('Échec de la connexion Atlassian');
      navigate('/login?error=sso_failed', { replace: true });
      return;
    }

    loginWithToken(token)
      .then(() => {
        toast.success('Connecté via Atlassian');
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        toast.error('Échec de la connexion Atlassian');
        navigate('/login?error=sso_failed', { replace: true });
      });
  }, [location.search, loginWithToken, navigate]);

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-slate-950 flex items-center justify-center">
      {/* Blob décoratif léger pour rester cohérent avec la page login */}
      <motion.div
        aria-hidden="true"
        className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 opacity-30 blur-[120px]"
        animate={{ x: [0, 60, 0], y: [0, -40, 0] }}
        transition={{ duration: 18, repeat: Number.POSITIVE_INFINITY, ease: 'easeInOut' }}
      />

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="flex flex-col items-center gap-4 text-center"
      >
        <div className="h-8 w-8 border-2 border-slate-600 border-t-cyan-400 rounded-full animate-spin" />
        <p className="text-sm text-slate-400">Connexion en cours…</p>
      </motion.div>
    </div>
  );
}

export default SsoCallback;
